import { useMutation } from 'react-query'
import { notification } from 'antd'

import { QUERY_KEYS } from '@api'

import { simulationApi } from './api'

const useSimulation = () => {
  const onError = () => {
    notification.error({
      message: 'Error trying to simulate',
    })
  }

  const { mutate, isLoading } = useMutation([QUERY_KEYS.SIMULATION], simulationApi.simulate, {
    onError,
  })

  return { simulate: mutate, isLoading }
}

export { useSimulation }
